<template>
  <div>
    <patrol-search :default-user-robot="2" title="AI电话（通话）" />
  </div>
</template>

<script>
import PatrolSearch from '@/views/actor/PatrolSearch'

export default {
  name: 'VideoAiChat',
  components: {
    PatrolSearch
  }
}
</script>
